export default {
  user: {},
  lastLogin: {},
  login_status: ''
};
